module.exports = __webpack_public_path__ + "static/media/eye.5d319421.svg";